var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 348.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{isolation:isolate}.cls-9{fill:#37a7f4}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    transform: "translate(-117 -89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    transform: "translate(801.048 7.092)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    cx: 64.771,
    cy: 64.771,
    r: 64.771,
    fill: "#fff",
    transform: "translate(-683.804 191.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    fill: "#2b5889",
    d: "M-583.562 201.684a65.108 65.108 0 0 0 19.291-90.032 65.107 65.107 0 0 0-90.029-19.29 65.105 65.105 0 0 0-19.291 90.031 65.1 65.1 0 0 0 19.291 19.291 65.086 65.086 0 0 1 70.738 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    fill: "#193f6a",
    d: "M-619.2 191.044c21.737 0 35.8 10.436 35.548 10.5a65.225 65.225 0 0 1-35.552 10.5 66.864 66.864 0 0 1-35.548-10.5c0-.287 13.815-10.5 35.552-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    fill: "#31f4cf",
    d: "M-654.3 310.562a65.107 65.107 0 0 0-19.291 90.032 65.107 65.107 0 0 0 90.032 19.29 65.107 65.107 0 0 0 19.291-90.031 65.112 65.112 0 0 0-19.291-19.291 65.086 65.086 0 0 1-70.741 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    fill: "#26cedb",
    d: "M-619.01 300.05a64.441 64.441 0 0 1 35.4 10.458c-.055.055-13.583 10.458-35.4 10.458s-35.15-10.458-35.4-10.458a64.914 64.914 0 0 1 35.4-10.458z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    d: "M-583.713 201.253a64.688 64.688 0 0 1-35.319 10.447 64.691 64.691 0 0 1-35.318-10.444 64.94 64.94 0 0 0-29.687 54.563c0 .474.034.939.043 1.411h33.531a4.181 4.181 0 0 1 3.837 2.526l7.059 16.4 15.788-54.16a4.248 4.248 0 0 1 4.056-3.006 4.18 4.18 0 0 1 3.986 3.09l11.009 41.033 6.456-19.022a4.173 4.173 0 0 1 3.881-2.835h.074a4.176 4.176 0 0 1 3.9 2.7l6.172 16.28h30.071q.15-2.19.151-4.417a64.938 64.938 0 0 0-29.69-54.563",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    d: "M-654.35 310.379a65.125 65.125 0 0 1 9.573-5.088c.382-.166.761-.326 1.143-.484q2.383-.98 4.854-1.774c.222-.074.437-.16.662-.228 1.833-.564 3.7-1.038 5.606-1.441.459-.1.93-.169 1.4-.259q2.217-.42 4.488-.687c.554-.065 1.1-.132 1.66-.182 1.959-.179 3.93-.3 5.935-.3 2 0 3.979.123 5.938.3.554.049 1.1.117 1.654.182q2.273.268 4.5.687c.459.089.921.16 1.38.259 1.9.4 3.776.878 5.615 1.445.216.065.425.148.641.216 1.657.53 3.28 1.13 4.879 1.786.376.154.748.311 1.121.474a65.417 65.417 0 0 1 9.588 5.094 65.043 65.043 0 0 0 28.423-41.793h-31.837a4.173 4.173 0 0 1-3.9-2.7l-3.068-8.1-7.149 21.041a4.179 4.179 0 0 1-5.3 2.611 4.179 4.179 0 0 1-2.689-2.87l-10.7-39.914-14.867 50.987a4.174 4.174 0 0 1-3.752 3c-.086.006-.173.009-.259.009a4.178 4.178 0 0 1-3.835-2.523l-10.57-24.547h-30.067a65 65 0 0 0 28.931 44.8",
    className: "cls-9"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDots);
export default __webpack_public_path__ + "static/media/LogoDots.7b848905167a0f1527fd027929712e9e.svg";
export { ForwardRef as ReactComponent };